export const enumLabelsToOptions = (
    enumLabels: Record<string, any>
): { value: any; label: string }[] =>
    Object.keys(enumLabels).map((labelKey) => ({
        value: labelKey,
        label: enumLabels[labelKey],
    }));
